const { __ } = wp.i18n;

const COPIED_CLASS = 'copied';
const NOT_COPIED_CLASS = 'not-copied';
const RESET_DELAY_MS = 1500;

/**
 * Copies the link associated with the specified button when clicked.
 *
 * @param {string} copyElClass - The class name of the copy link button.
 * @param {string} linkAtt     - The name of the data attribute containing the link.
 */
export function copyLink( copyElClass = 'js-qala-qr-codes-copy-link-button', linkAtt = 'data-qr_code_link' ) {
	if ( ! copyElClass.length || ! linkAtt.length ) {
		return;
	}

	const copyLinkButtons = document.querySelectorAll( '.' + copyElClass );

	copyLinkButtons.forEach( button => {
		button.addEventListener( 'click', () => {
			const qrCodeLink = button.getAttribute( linkAtt );

			window.navigator.clipboard.writeText( qrCodeLink )
				.then( () => {
					button.textContent = __( 'Copied', 'qala-qr-codes' );
					button.classList.add( COPIED_CLASS );

					setTimeout( () => {
						button.textContent = __( 'Copy link', 'qala-qr-codes' );
						button.classList.remove( COPIED_CLASS );
					}, RESET_DELAY_MS );
				} )
				.catch( error => { // eslint-disable-line no-unused-vars
					button.textContent = __( 'Not Copied', 'qala-qr-codes' );
					button.classList.add( NOT_COPIED_CLASS );

					setTimeout( () => {
						button.textContent = __( 'Copy link', 'qala-qr-codes' );
						button.classList.remove( NOT_COPIED_CLASS );
					}, RESET_DELAY_MS );
				} );
		} );
	} );
}
